// Blocked users dialog component for the library page

import React from 'react';
import BlockedUsersContent from '../moderation/BlockedUsersContent';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';

const BlockedUsersDialog: React.FC<LibraryDialogOutletProps> = ({
  user,
  dialog,
  playerAccess,
  setDialog,
}) => {
  if (!user) {
    return null;
  }

  return (
    <Dialog
      open={dialog === 'blocked-users'}
      onOpenChange={(nextOpen) => setDialog(nextOpen ? 'blocked-users' : null)}
    >
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Blocked Users</DialogTitle>
          <DialogDescription>
            Users from your Twitch blocked and banned lists are prevented from
            joining when this setting is enabled.
          </DialogDescription>
        </DialogHeader>
        <BlockedUsersContent
          modSettings={playerAccess.modSettings}
          syncStatus={playerAccess.syncStatus}
        />
      </DialogContent>
    </Dialog>
  );
};

export default BlockedUsersDialog;
